import script from "./BlockTypeMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockTypeMenu.vue?vue&type=script&setup=true&lang=js"

import "./BlockTypeMenu.vue?vue&type=style&index=0&id=45178e6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45178e6a"]])

export default __exports__